import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
var AvueSelectTemplateService = /*#__PURE__*/function () {
  function AvueSelectTemplateService() {
    _classCallCheck(this, AvueSelectTemplateService);
  }
  _createClass(AvueSelectTemplateService, [{
    key: "abstractQueryDictData",
    value:
    /**
     *查询字典数据
     * @param dictType 字典类型code
     * */
    function () {
      var _abstractQueryDictData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dictType, source) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Error('必须在子类中实现该方法'));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function abstractQueryDictData(_x, _x2) {
        return _abstractQueryDictData.apply(this, arguments);
      }
      return abstractQueryDictData;
    }()
  }, {
    key: "abstractLabelCode",
    value: function abstractLabelCode() {
      return 'name';
    }
  }, {
    key: "abstractValueCode",
    value: function abstractValueCode() {
      return 'code';
    }
  }, {
    key: "queryDictData",
    value: function () {
      var _queryDictData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dictType, source) {
        var response, labelName, valueName, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.abstractQueryDictData(dictType, source);
              case 2:
                response = _context2.sent;
                labelName = this.abstractLabelCode();
                valueName = this.abstractValueCode();
                result = response.data.map(function (ele) {
                  return {
                    label: ele[labelName],
                    value: ele[valueName]
                  };
                });
                return _context2.abrupt("return", result);
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function queryDictData(_x3, _x4) {
        return _queryDictData.apply(this, arguments);
      }
      return queryDictData;
    }()
  }]);
  return AvueSelectTemplateService;
}();
export { AvueSelectTemplateService as default };